import { 
    getAuth, 
    setPersistence,
    GoogleAuthProvider,
    browserLocalPersistence, 
} from "firebase/auth";
import { initializeApp } from "firebase/app";
import firebaseConfig from '@keys/firebase-user-key.json'

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();

if(import.meta.env.DEV)
auth.onAuthStateChanged((user) => {
    console.log("AUTH CHANGE", user?.metadata)
});

if(import.meta.env.DEV)
auth.onIdTokenChanged((user)=>{
    console.log("TOKEN REFRESH", user?.metadata)
})

setPersistence(auth, browserLocalPersistence)